<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->
<div [attr.id]="id || null" role="alert" aria-live="assertive" aria-atomic="true">
  @for (message of messages; track message) {
    <profile-pds-p-text
      p-text
      class="profile:ps-static-md profile:my-fluid-sm profile:border-l-4 profile:border-solid profile:border-l-error-frosted"
      >{{ message }}</profile-pds-p-text
    >
  }
</div>
